"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializerV2 = void 0;
class InitializerV2 {
    constructor(dependencies = []) {
        this.dependencies = [];
        this.isInitialized = false;
        this.getInitialized = () => {
            if (!this.initialized) {
                throw new Error();
            }
            return this.initialized;
        };
        this.setInitialized = (_initialized) => {
            this.isInitialized = true;
            this.initialized = _initialized;
        };
        this.dependencies = dependencies;
    }
}
exports.InitializerV2 = InitializerV2;
//# sourceMappingURL=initializer.js.map